import styled from 'styled-components'

import { Text } from '@doordash/design-language'

export const PageExplanation = styled(Text)`
  color: $(Colors.SystemGrey10);
`
